// @ts-nocheck
/* eslint-disable */

import { AllTypesProps, ReturnTypes, Ops } from './const';


export const HOST="Specify host"


export const HEADERS = {}
export const apiSubscription = (options: chainOptions) => (query: string) => {
  try {
    const queryString = options[0] + '?query=' + encodeURIComponent(query);
    const wsString = queryString.replace('http', 'ws');
    const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
    const webSocketOptions = options[1]?.websocket || [host];
    const ws = new WebSocket(...webSocketOptions);
    return {
      ws,
      on: (e: (args: any) => void) => {
        ws.onmessage = (event: any) => {
          if (event.data) {
            const parsed = JSON.parse(event.data);
            const data = parsed.data;
            return e(data);
          }
        };
      },
      off: (e: (args: any) => void) => {
        ws.onclose = e;
      },
      error: (e: (args: any) => void) => {
        ws.onerror = e;
      },
      open: (e: () => void) => {
        ws.onopen = e;
      },
    };
  } catch {
    throw new Error('No websockets implemented');
  }
};
const handleFetchResponse = (response: Response): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response
        .text()
        .then((text) => {
          try {
            reject(JSON.parse(text));
          } catch (err) {
            reject(text);
          }
        })
        .catch(reject);
    });
  }
  return response.json() as Promise<GraphQLResponse>;
};

export const apiFetch =
  (options: fetchOptions) =>
  (query: string, variables: Record<string, unknown> = {}) => {
    const fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      return fetch(`${options[0]}?query=${encodeURIComponent(query)}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetch(`${options[0]}`, {
      body: JSON.stringify({ query, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      ...fetchOptions,
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };

export const InternalsBuildQuery = ({
  ops,
  props,
  returns,
  options,
  scalars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  options?: OperationOptions;
  scalars?: ScalarDefinition;
}) => {
  const ibb = (
    k: string,
    o: InputValueType | VType,
    p = '',
    root = true,
    vars: Array<{ name: string; graphQLType: string }> = [],
  ): string => {
    const keyForPath = purifyGraphQLKey(k);
    const newPath = [p, keyForPath].join(SEPARATOR);
    if (!o) {
      return '';
    }
    if (typeof o === 'boolean' || typeof o === 'number') {
      return k;
    }
    if (typeof o === 'string') {
      return `${k} ${o}`;
    }
    if (Array.isArray(o)) {
      const args = InternalArgsBuilt({
        props,
        returns,
        ops,
        scalars,
        vars,
      })(o[0], newPath);
      return `${ibb(args ? `${k}(${args})` : k, o[1], p, false, vars)}`;
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(`${alias}:${operationName}`, operation, p, false, vars);
        })
        .join('\n');
    }
    const hasOperationName = root && options?.operationName ? ' ' + options.operationName : '';
    const keyForDirectives = o.__directives ?? '';
    const query = `{${Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map((e) => ibb(...e, [p, `field<>${keyForPath}`].join(SEPARATOR), false, vars))
      .join('\n')}}`;
    if (!root) {
      return `${k} ${keyForDirectives}${hasOperationName} ${query}`;
    }
    const varsString = vars.map((v) => `${v.name}: ${v.graphQLType}`).join(', ');
    return `${k} ${keyForDirectives}${hasOperationName}${varsString ? `(${varsString})` : ''} ${query}`;
  };
  return ibb;
};

type UnionOverrideKeys<T, U> = Omit<T, keyof U> & U;

export const Thunder =
  <SCLR extends ScalarDefinition>(fn: FetchFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    return fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
      ops?.variables,
    ).then((data) => {
      if (options?.scalars) {
        return decodeScalarsInResponse({
          response: data,
          initialOp: operation,
          initialZeusQuery: o as VType,
          returns: ReturnTypes,
          scalars: options.scalars,
          ops: Ops,
        });
      }
      return data;
    }) as Promise<InputType<GraphQLTypes[R], Z, UnionOverrideKeys<SCLR, OVERRIDESCLR>>>;
  };

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));

export const SubscriptionThunder =
  <SCLR extends ScalarDefinition>(fn: SubscriptionFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: ExtractVariables<Z> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    type CombinedSCLR = UnionOverrideKeys<SCLR, OVERRIDESCLR>;
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
    ) as SubscriptionToGraphQL<Z, GraphQLTypes[R], CombinedSCLR>;
    if (returnedFunction?.on && options?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => {
          if (options?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: options.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>,
>(
  operation: O,
  o: Z,
  ops?: {
    operationOptions?: OperationOptions;
    scalars?: ScalarDefinition;
  },
) =>
  InternalsBuildQuery({
    props: AllTypesProps,
    returns: ReturnTypes,
    ops: Ops,
    options: ops?.operationOptions,
    scalars: ops?.scalars,
  })(operation, o as VType);

export const ZeusSelect = <T>() => ((t: unknown) => t) as SelectionFunction<T>;

export const Selector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();

export const TypeFromSelector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();
export const Gql = Chain(HOST, {
  headers: {
    'Content-Type': 'application/json',
    ...HEADERS,
  },
});

export const ZeusScalars = ZeusSelect<ScalarCoders>();

type ScalarsSelector<T> = {
  [X in Required<{
    [P in keyof T]: T[P] extends number | string | undefined | boolean ? P : never;
  }>[keyof T]]: true;
};

export const fields = <T extends keyof ModelTypes>(k: T) => {
  const t = ReturnTypes[k];
  const o = Object.fromEntries(
    Object.entries(t)
      .filter(([, value]) => {
        const isReturnType = ReturnTypes[value as string];
        if (!isReturnType || (typeof isReturnType === 'string' && isReturnType.startsWith('scalar.'))) {
          return true;
        }
      })
      .map(([key]) => [key, true as const]),
  );
  return o as ScalarsSelector<ModelTypes[T]>;
};

export const decodeScalarsInResponse = <O extends Operations>({
  response,
  scalars,
  returns,
  ops,
  initialZeusQuery,
  initialOp,
}: {
  ops: O;
  response: any;
  returns: ReturnTypesType;
  scalars?: Record<string, ScalarResolver | undefined>;
  initialOp: keyof O;
  initialZeusQuery: InputValueType | VType;
}) => {
  if (!scalars) {
    return response;
  }
  const builder = PrepareScalarPaths({
    ops,
    returns,
  });

  const scalarPaths = builder(initialOp as string, ops[initialOp], initialZeusQuery);
  if (scalarPaths) {
    const r = traverseResponse({ scalarPaths, resolvers: scalars })(initialOp as string, response, [ops[initialOp]]);
    return r;
  }
  return response;
};

export const traverseResponse = ({
  resolvers,
  scalarPaths,
}: {
  scalarPaths: { [x: string]: `scalar.${string}` };
  resolvers: {
    [x: string]: ScalarResolver | undefined;
  };
}) => {
  const ibb = (k: string, o: InputValueType | VType, p: string[] = []): unknown => {
    if (Array.isArray(o)) {
      return o.map((eachO) => ibb(k, eachO, p));
    }
    if (o == null) {
      return o;
    }
    const scalarPathString = p.join(SEPARATOR);
    const currentScalarString = scalarPaths[scalarPathString];
    if (currentScalarString) {
      const currentDecoder = resolvers[currentScalarString.split('.')[1]]?.decode;
      if (currentDecoder) {
        return currentDecoder(o);
      }
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string' || !o) {
      return o;
    }
    const entries = Object.entries(o).map(([k, v]) => [k, ibb(k, v, [...p, purifyGraphQLKey(k)])] as const);
    const objectFromEntries = entries.reduce<Record<string, unknown>>((a, [k, v]) => {
      a[k] = v;
      return a;
    }, {});
    return objectFromEntries;
  };
  return ibb;
};

export type AllTypesPropsType = {
  [x: string]:
    | undefined
    | `scalar.${string}`
    | 'enum'
    | {
        [x: string]:
          | undefined
          | string
          | {
              [x: string]: string | undefined;
            };
      };
};

export type ReturnTypesType = {
  [x: string]:
    | {
        [x: string]: string | undefined;
      }
    | `scalar.${string}`
    | undefined;
};
export type InputValueType = {
  [x: string]: undefined | boolean | string | number | [any, undefined | boolean | InputValueType] | InputValueType;
};
export type VType =
  | undefined
  | boolean
  | string
  | number
  | [any, undefined | boolean | InputValueType]
  | InputValueType;

export type PlainType = boolean | number | string | null | undefined;
export type ZeusArgsType =
  | PlainType
  | {
      [x: string]: ZeusArgsType;
    }
  | Array<ZeusArgsType>;

export type Operations = Record<string, string>;

export type VariableDefinition = {
  [x: string]: unknown;
};

export const SEPARATOR = '|';

export type fetchOptions = Parameters<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (...args: infer R) => WebSocket ? R : never;
export type chainOptions = [fetchOptions[0], fetchOptions[1] & { websocket?: websocketOptions }] | [fetchOptions[0]];
export type FetchFunction = (query: string, variables?: Record<string, unknown>) => Promise<any>;
export type SubscriptionFunction = (query: string) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;

export type OperationOptions = {
  operationName?: string;
};

export type ScalarCoder = Record<string, (s: unknown) => string>;

export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
export class GraphQLError extends Error {
  constructor(public response: GraphQLResponse) {
    super('');
    console.error(response);
  }
  toString() {
    return 'GraphQL Response Error';
  }
}
export type GenericOperation<O> = O extends keyof typeof Ops ? typeof Ops[O] : never;
export type ThunderGraphQLOptions<SCLR extends ScalarDefinition> = {
  scalars?: SCLR | ScalarCoders;
};

const ExtractScalar = (mappedParts: string[], returns: ReturnTypesType): `scalar.${string}` | undefined => {
  if (mappedParts.length === 0) {
    return;
  }
  const oKey = mappedParts[0];
  const returnP1 = returns[oKey];
  if (typeof returnP1 === 'object') {
    const returnP2 = returnP1[mappedParts[1]];
    if (returnP2) {
      return ExtractScalar([returnP2, ...mappedParts.slice(2)], returns);
    }
    return undefined;
  }
  return returnP1 as `scalar.${string}` | undefined;
};

export const PrepareScalarPaths = ({ ops, returns }: { returns: ReturnTypesType; ops: Operations }) => {
  const ibb = (
    k: string,
    originalKey: string,
    o: InputValueType | VType,
    p: string[] = [],
    pOriginals: string[] = [],
    root = true,
  ): { [x: string]: `scalar.${string}` } | undefined => {
    if (!o) {
      return;
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string') {
      const extractionArray = [...pOriginals, originalKey];
      const isScalar = ExtractScalar(extractionArray, returns);
      if (isScalar?.startsWith('scalar')) {
        const partOfTree = {
          [[...p, k].join(SEPARATOR)]: isScalar,
        };
        return partOfTree;
      }
      return {};
    }
    if (Array.isArray(o)) {
      return ibb(k, k, o[1], p, pOriginals, false);
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(alias, operationName, operation, p, pOriginals, false);
        })
        .reduce((a, b) => ({
          ...a,
          ...b,
        }));
    }
    const keyName = root ? ops[k] : k;
    return Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map(([k, v]) => {
        // Inline fragments shouldn't be added to the path as they aren't a field
        const isInlineFragment = originalKey.match(/^...\s*on/) != null;
        return ibb(
          k,
          k,
          v,
          isInlineFragment ? p : [...p, purifyGraphQLKey(keyName || k)],
          isInlineFragment ? pOriginals : [...pOriginals, purifyGraphQLKey(originalKey)],
          false,
        );
      })
      .reduce((a, b) => ({
        ...a,
        ...b,
      }));
  };
  return ibb;
};

export const purifyGraphQLKey = (k: string) => k.replace(/\([^)]*\)/g, '').replace(/^[^:]*\:/g, '');

const mapPart = (p: string) => {
  const [isArg, isField] = p.split('<>');
  if (isField) {
    return {
      v: isField,
      __type: 'field',
    } as const;
  }
  return {
    v: isArg,
    __type: 'arg',
  } as const;
};

type Part = ReturnType<typeof mapPart>;

export const ResolveFromPath = (props: AllTypesPropsType, returns: ReturnTypesType, ops: Operations) => {
  const ResolvePropsType = (mappedParts: Part[]) => {
    const oKey = ops[mappedParts[0].v];
    const propsP1 = oKey ? props[oKey] : props[mappedParts[0].v];
    if (propsP1 === 'enum' && mappedParts.length === 1) {
      return 'enum';
    }
    if (typeof propsP1 === 'string' && propsP1.startsWith('scalar.') && mappedParts.length === 1) {
      return propsP1;
    }
    if (typeof propsP1 === 'object') {
      if (mappedParts.length < 2) {
        return 'not';
      }
      const propsP2 = propsP1[mappedParts[1].v];
      if (typeof propsP2 === 'string') {
        return rpp(
          `${propsP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
      if (typeof propsP2 === 'object') {
        if (mappedParts.length < 3) {
          return 'not';
        }
        const propsP3 = propsP2[mappedParts[2].v];
        if (propsP3 && mappedParts[2].__type === 'arg') {
          return rpp(
            `${propsP3}${SEPARATOR}${mappedParts
              .slice(3)
              .map((mp) => mp.v)
              .join(SEPARATOR)}`,
          );
        }
      }
    }
  };
  const ResolveReturnType = (mappedParts: Part[]) => {
    if (mappedParts.length === 0) {
      return 'not';
    }
    const oKey = ops[mappedParts[0].v];
    const returnP1 = oKey ? returns[oKey] : returns[mappedParts[0].v];
    if (typeof returnP1 === 'object') {
      if (mappedParts.length < 2) return 'not';
      const returnP2 = returnP1[mappedParts[1].v];
      if (returnP2) {
        return rpp(
          `${returnP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
    }
  };
  const rpp = (path: string): 'enum' | 'not' | `scalar.${string}` => {
    const parts = path.split(SEPARATOR).filter((l) => l.length > 0);
    const mappedParts = parts.map(mapPart);
    const propsP1 = ResolvePropsType(mappedParts);
    if (propsP1) {
      return propsP1;
    }
    const returnP1 = ResolveReturnType(mappedParts);
    if (returnP1) {
      return returnP1;
    }
    return 'not';
  };
  return rpp;
};

export const InternalArgsBuilt = ({
  props,
  ops,
  returns,
  scalars,
  vars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  scalars?: ScalarDefinition;
  vars: Array<{ name: string; graphQLType: string }>;
}) => {
  const arb = (a: ZeusArgsType, p = '', root = true): string => {
    if (typeof a === 'string') {
      if (a.startsWith(START_VAR_NAME)) {
        const [varName, graphQLType] = a.replace(START_VAR_NAME, '$').split(GRAPHQL_TYPE_SEPARATOR);
        const v = vars.find((v) => v.name === varName);
        if (!v) {
          vars.push({
            name: varName,
            graphQLType,
          });
        } else {
          if (v.graphQLType !== graphQLType) {
            throw new Error(
              `Invalid variable exists with two different GraphQL Types, "${v.graphQLType}" and ${graphQLType}`,
            );
          }
        }
        return varName;
      }
    }
    const checkType = ResolveFromPath(props, returns, ops)(p);
    if (checkType.startsWith('scalar.')) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, ...splittedScalar] = checkType.split('.');
      const scalarKey = splittedScalar.join('.');
      return (scalars?.[scalarKey]?.encode?.(a) as string) || JSON.stringify(a);
    }
    if (Array.isArray(a)) {
      return `[${a.map((arr) => arb(arr, p, false)).join(', ')}]`;
    }
    if (typeof a === 'string') {
      if (checkType === 'enum') {
        return a;
      }
      return `${JSON.stringify(a)}`;
    }
    if (typeof a === 'object') {
      if (a === null) {
        return `null`;
      }
      const returnedObjectString = Object.entries(a)
        .filter(([, v]) => typeof v !== 'undefined')
        .map(([k, v]) => `${k}: ${arb(v, [p, k].join(SEPARATOR), false)}`)
        .join(',\n');
      if (!root) {
        return `{${returnedObjectString}}`;
      }
      return returnedObjectString;
    }
    return `${a}`;
  };
  return arb;
};

export const resolverFor = <X, T extends keyof ResolverInputTypes, Z extends keyof ResolverInputTypes[T]>(
  type: T,
  field: Z,
  fn: (
    args: Required<ResolverInputTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : never,
) => fn as (args?: any, source?: any) => ReturnType<typeof fn>;

export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<UnwrapPromise<ReturnType<T>>>;
export type ZeusHook<
  T extends (...args: any[]) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>,
> = ZeusState<ReturnType<T>[N]>;

export type WithTypeNameValue<T> = T & {
  __typename?: boolean;
  __directives?: string;
};
export type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
export type ScalarDefinition = Record<string, ScalarResolver>;

type IsScalar<S, SCLR extends ScalarDefinition> = S extends 'scalar' & { name: infer T }
  ? T extends keyof SCLR
    ? SCLR[T]['decode'] extends (s: unknown) => unknown
      ? ReturnType<SCLR[T]['decode']>
      : unknown
    : unknown
  : S;
type IsArray<T, U, SCLR extends ScalarDefinition> = T extends Array<infer R>
  ? InputType<R, U, SCLR>[]
  : InputType<T, U, SCLR>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;
type BaseZeusResolver = boolean | 1 | string | Variable<any, string>;

type IsInterfaced<SRC extends DeepAnify<DST>, DST, SCLR extends ScalarDefinition> = FlattenArray<SRC> extends
  | ZEUS_INTERFACES
  | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P], SCLR>
          : IsArray<R, '__typename' extends keyof DST ? { __typename: true } : Record<string, never>, SCLR>
        : never;
    }[keyof SRC] & {
      [P in keyof Omit<
        Pick<
          SRC,
          {
            [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
          }[keyof DST]
        >,
        '__typename'
      >]: IsPayLoad<DST[P]> extends BaseZeusResolver ? IsScalar<SRC[P], SCLR> : IsArray<SRC[P], DST[P], SCLR>;
    }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends BaseZeusResolver
        ? IsScalar<SRC[P], SCLR>
        : IsArray<SRC[P], DST[P], SCLR>;
    };

export type MapType<SRC, DST, SCLR extends ScalarDefinition> = SRC extends DeepAnify<DST>
  ? IsInterfaced<SRC, DST, SCLR>
  : never;
// eslint-disable-next-line @typescript-eslint/ban-types
export type InputType<SRC, DST, SCLR extends ScalarDefinition = {}> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P], SCLR>[keyof MapType<SRC, R[P], SCLR>];
    } & MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>, SCLR>
  : MapType<SRC, IsPayLoad<DST>, SCLR>;
export type SubscriptionToGraphQL<Z, T, SCLR extends ScalarDefinition> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: () => void;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export type FromSelector<SELECTOR, NAME extends keyof GraphQLTypes, SCLR extends ScalarDefinition = {}> = InputType<
  GraphQLTypes[NAME],
  SELECTOR,
  SCLR
>;

export type ScalarResolver = {
  encode?: (s: unknown) => string;
  decode?: (s: unknown) => unknown;
};

export type SelectionFunction<V> = <Z extends V>(
  t: Z & {
    [P in keyof Z]: P extends keyof V ? Z[P] : never;
  },
) => Z;

type BuiltInVariableTypes = {
  ['String']: string;
  ['Int']: number;
  ['Float']: number;
  ['ID']: unknown;
  ['Boolean']: boolean;
};
type AllVariableTypes = keyof BuiltInVariableTypes | keyof ZEUS_VARIABLES;
type VariableRequired<T extends string> = `${T}!` | T | `[${T}]` | `[${T}]!` | `[${T}!]` | `[${T}!]!`;
type VR<T extends string> = VariableRequired<VariableRequired<T>>;

export type GraphQLVariableType = VR<AllVariableTypes>;

type ExtractVariableTypeString<T extends string> = T extends VR<infer R1>
  ? R1 extends VR<infer R2>
    ? R2 extends VR<infer R3>
      ? R3 extends VR<infer R4>
        ? R4 extends VR<infer R5>
          ? R5
          : R4
        : R3
      : R2
    : R1
  : T;

type DecomposeType<T, Type> = T extends `[${infer R}]`
  ? Array<DecomposeType<R, Type>> | undefined
  : T extends `${infer R}!`
  ? NonNullable<DecomposeType<R, Type>>
  : Type | undefined;

type ExtractTypeFromGraphQLType<T extends string> = T extends keyof ZEUS_VARIABLES
  ? ZEUS_VARIABLES[T]
  : T extends keyof BuiltInVariableTypes
  ? BuiltInVariableTypes[T]
  : any;

export type GetVariableType<T extends string> = DecomposeType<
  T,
  ExtractTypeFromGraphQLType<ExtractVariableTypeString<T>>
>;

type UndefinedKeys<T> = {
  [K in keyof T]-?: T[K] extends NonNullable<T[K]> ? never : K;
}[keyof T];

type WithNullableKeys<T> = Pick<T, UndefinedKeys<T>>;
type WithNonNullableKeys<T> = Omit<T, UndefinedKeys<T>>;

type OptionalKeys<T> = {
  [P in keyof T]?: T[P];
};

export type WithOptionalNullables<T> = OptionalKeys<WithNullableKeys<T>> & WithNonNullableKeys<T>;

export type Variable<T extends GraphQLVariableType, Name extends string> = {
  ' __zeus_name': Name;
  ' __zeus_type': T;
};

export type ExtractVariablesDeep<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariablesDeep<Query[K]>> }[keyof Query]>;

export type ExtractVariables<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends [infer Inputs, infer Outputs]
  ? ExtractVariablesDeep<Inputs> & ExtractVariables<Outputs>
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariables<Query[K]>> }[keyof Query]>;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;

export const START_VAR_NAME = `$ZEUS_VAR`;
export const GRAPHQL_TYPE_SEPARATOR = `__$GRAPHQL__`;

export const $ = <Type extends GraphQLVariableType, Name extends string>(name: Name, graphqlType: Type) => {
  return (START_VAR_NAME + name + GRAPHQL_TYPE_SEPARATOR + graphqlType) as unknown as Variable<Type, Name>;
};
type ZEUS_INTERFACES = never
export type ScalarCoders = {
	DateTime?: ScalarResolver;
	JSON?: ScalarResolver;
}
type ZEUS_UNIONS = GraphQLTypes["AuthType"]

export type ValueTypes = {
    ["Health"]: AliasType<{
	env?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Answer"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	isCorrect?:boolean | `@${string}`,
	quiz?:ValueTypes["Quiz"],
	quizId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AnswersWithoutCorrect"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	quiz?:ValueTypes["Quiz"],
	quizId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Quiz"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	question?:boolean | `@${string}`,
	quizType?:boolean | `@${string}`,
	answers?:ValueTypes["Answer"],
	challenge?:ValueTypes["Challenge"],
	challengeId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["QuizType"]:QuizType;
	["Thematic"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	asset?:boolean | `@${string}`,
	challenges?:ValueTypes["Challenge"],
		__typename?: boolean | `@${string}`
}>;
	["Challenge"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	asset?:boolean | `@${string}`,
	helpText?:boolean | `@${string}`,
	difficulty?:boolean | `@${string}`,
	quizzes?:ValueTypes["Quiz"],
	trackings?:ValueTypes["Tracking"],
	thematic?:ValueTypes["Thematic"],
	thematicId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ChallengeDifficulty"]:ChallengeDifficulty;
	["QuizResponse"]: AliasType<{
	id?:boolean | `@${string}`,
	isCorrect?:boolean | `@${string}`,
	done?:boolean | `@${string}`,
	quizId?:boolean | `@${string}`,
	challenge?:ValueTypes["Challenge"],
	challengeId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Tracking"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	user?:ValueTypes["Users"],
	userId?:boolean | `@${string}`,
	challengeStatus?:boolean | `@${string}`,
	challengeTrackingStatus?:boolean | `@${string}`,
	challenge?:ValueTypes["Challenge"],
	quizResponses?:ValueTypes["QuizResponse"],
		__typename?: boolean | `@${string}`
}>;
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:unknown;
	["ChallengeStatus"]:ChallengeStatus;
	["ChallengeTrackingStatus"]:ChallengeTrackingStatus;
	["Users"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	password?:boolean | `@${string}`,
	passwordResetToken?:boolean | `@${string}`,
	passwordResetExpiryDate?:boolean | `@${string}`,
	activateAccountToken?:boolean | `@${string}`,
	activateAccountExpiryDate?:boolean | `@${string}`,
	emailVerified?:boolean | `@${string}`,
	verifyEmailToken?:boolean | `@${string}`,
	verifyEmailExpiryDate?:boolean | `@${string}`,
	unlockedDate?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	ecole?:boolean | `@${string}`,
	refreshToken?:boolean | `@${string}`,
	role?:ValueTypes["Roles"],
	roleId?:boolean | `@${string}`,
	tutorEmail?:boolean | `@${string}`,
	satisfactionQuiz?:boolean | `@${string}`,
	satisfactionQuizContent?:boolean | `@${string}`,
	trackingEntity?:ValueTypes["Tracking"],
	motionViewed?:boolean | `@${string}`,
	firstCardDraw?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AccountStatus"]:AccountStatus;
	/** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
["JSON"]:unknown;
	["UserPagination"]: AliasType<{
	users?:ValueTypes["Users"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Roles"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	users?:ValueTypes["Users"],
		__typename?: boolean | `@${string}`
}>;
	["UniqueAuth"]: AliasType<{
	access_token?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	ecole?:boolean | `@${string}`,
	sub?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Mail"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Stats"]: AliasType<{
	question?:boolean | `@${string}`,
	answerNumber?:boolean | `@${string}`,
	yes?:boolean | `@${string}`,
	littleYes?:boolean | `@${string}`,
	middle?:boolean | `@${string}`,
	littleNo?:boolean | `@${string}`,
	no?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StatsPagination"]: AliasType<{
	stats?:ValueTypes["Stats"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Query"]: AliasType<{
	getHealthGql?:ValueTypes["Health"],
getRole?: [{	id: number | Variable<any, string>},ValueTypes["Roles"]],
	getRoles?:ValueTypes["Roles"],
getMail?: [{	id: number | Variable<any, string>},ValueTypes["Mail"]],
	getMails?:ValueTypes["Mail"],
	sendMail?:boolean | `@${string}`,
loginAsGuest?: [{	email: string | Variable<any, string>},ValueTypes["AuthType"]],
login?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>},ValueTypes["AuthType"]],
uniqueAuthFromSso?: [{	code: string | Variable<any, string>},ValueTypes["UniqueAuth"]],
getUser?: [{	id: number | Variable<any, string>},ValueTypes["Users"]],
	getUsers?:ValueTypes["Users"],
getFilteredUsers?: [{	findManyUserWithFiltersInput: ValueTypes["FindManyUserWithFiltersInput"] | Variable<any, string>},ValueTypes["UserPagination"]],
	getThematics?:ValueTypes["Thematic"],
getFilteredStats?: [{	findManyStatWithFiltersInput: ValueTypes["FindManyStatWithFiltersInput"] | Variable<any, string>},ValueTypes["StatsPagination"]],
		__typename?: boolean | `@${string}`
}>;
	["AuthType"]: AliasType<{		["...on Tokens"]?: ValueTypes["Tokens"],
		["...on CustomError"]?: ValueTypes["CustomError"]
		__typename?: boolean | `@${string}`
}>;
	["Tokens"]: AliasType<{
	access_token?:boolean | `@${string}`,
	refresh_token?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomError"]: AliasType<{
	error?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["EError"]:EError;
	["FindManyUserWithFiltersInput"]: {
	skip: number | Variable<any, string>,
	take: number | Variable<any, string>,
	searchInput: string | Variable<any, string>,
	orderBy?: ValueTypes["UserOrderByInput"] | undefined | null | Variable<any, string>,
	filterBy?: ValueTypes["UserFilterByInput"] | undefined | null | Variable<any, string>
};
	["UserOrderByInput"]: {
	email?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	firstName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	lastName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	lastConnectionAt?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	role?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<number> | undefined | null | Variable<any, string>
};
	["FindManyStatWithFiltersInput"]: {
	skip: number | Variable<any, string>,
	take: number | Variable<any, string>
};
	["Mutation"]: AliasType<{
askForResetPassword?: [{	email: string | Variable<any, string>},boolean | `@${string}`],
resetPassword?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
verifyEmail?: [{	email: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
register?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	firstName: string | Variable<any, string>,	lastName: string | Variable<any, string>},ValueTypes["AuthType"]],
askForRegister?: [{	registerUserInput: ValueTypes["RegisterUserInput"] | Variable<any, string>},boolean | `@${string}`],
finishRegister?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	firstName: string | Variable<any, string>,	lastName: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
finishRegisterAsGuest?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	firstName: string | Variable<any, string>,	lastName: string | Variable<any, string>},boolean | `@${string}`],
	refresh?:ValueTypes["AuthType"],
	logout?:boolean | `@${string}`,
createUser?: [{	createUserInput: ValueTypes["CreateUserInput"] | Variable<any, string>},ValueTypes["Users"]],
updateUser?: [{	updateUserInput: ValueTypes["UpdateUserInput"] | Variable<any, string>},ValueTypes["Users"]],
deleteUser?: [{	id: number | Variable<any, string>},boolean | `@${string}`],
updateTutorEmail?: [{	userId: number | Variable<any, string>,	tutorEmail: string | Variable<any, string>},ValueTypes["Users"]],
updateSatisfactionQuiz?: [{	userId: number | Variable<any, string>,	content: ValueTypes["JSON"] | Variable<any, string>},ValueTypes["Users"]],
updateMotionViewed?: [{	userId: number | Variable<any, string>},ValueTypes["Users"]],
updateFirstCardDraw?: [{	userId: number | Variable<any, string>},ValueTypes["Users"]],
createTracking?: [{	userId: number | Variable<any, string>,	thematicId: number | Variable<any, string>},ValueTypes["Tracking"]],
deleteTracking?: [{	trackingId: number | Variable<any, string>},boolean | `@${string}`],
validateTracking?: [{	trackingId: number | Variable<any, string>,	text: string | Variable<any, string>},boolean | `@${string}`],
validateQuiz?: [{	quizId: number | Variable<any, string>,	trackingId: number | Variable<any, string>,	answerId: number | Variable<any, string>},ValueTypes["Tracking"]],
		__typename?: boolean | `@${string}`
}>;
	["RegisterUserInput"]: {
	email: string | Variable<any, string>,
	roleId: number | Variable<any, string>
};
	["CreateUserInput"]: {
	email: string | Variable<any, string>,
	password: string | Variable<any, string>,
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	roleId: number | Variable<any, string>
};
	["UpdateUserInput"]: {
	email?: string | undefined | null | Variable<any, string>,
	firstName?: string | undefined | null | Variable<any, string>,
	lastName?: string | undefined | null | Variable<any, string>,
	roleId?: number | undefined | null | Variable<any, string>,
	id: number | Variable<any, string>
}
  }

export type ResolverInputTypes = {
    ["Health"]: AliasType<{
	env?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Answer"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	isCorrect?:boolean | `@${string}`,
	quiz?:ResolverInputTypes["Quiz"],
	quizId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AnswersWithoutCorrect"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	quiz?:ResolverInputTypes["Quiz"],
	quizId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Quiz"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	question?:boolean | `@${string}`,
	quizType?:boolean | `@${string}`,
	answers?:ResolverInputTypes["Answer"],
	challenge?:ResolverInputTypes["Challenge"],
	challengeId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["QuizType"]:QuizType;
	["Thematic"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	asset?:boolean | `@${string}`,
	challenges?:ResolverInputTypes["Challenge"],
		__typename?: boolean | `@${string}`
}>;
	["Challenge"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	asset?:boolean | `@${string}`,
	helpText?:boolean | `@${string}`,
	difficulty?:boolean | `@${string}`,
	quizzes?:ResolverInputTypes["Quiz"],
	trackings?:ResolverInputTypes["Tracking"],
	thematic?:ResolverInputTypes["Thematic"],
	thematicId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ChallengeDifficulty"]:ChallengeDifficulty;
	["QuizResponse"]: AliasType<{
	id?:boolean | `@${string}`,
	isCorrect?:boolean | `@${string}`,
	done?:boolean | `@${string}`,
	quizId?:boolean | `@${string}`,
	challenge?:ResolverInputTypes["Challenge"],
	challengeId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Tracking"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	user?:ResolverInputTypes["Users"],
	userId?:boolean | `@${string}`,
	challengeStatus?:boolean | `@${string}`,
	challengeTrackingStatus?:boolean | `@${string}`,
	challenge?:ResolverInputTypes["Challenge"],
	quizResponses?:ResolverInputTypes["QuizResponse"],
		__typename?: boolean | `@${string}`
}>;
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:unknown;
	["ChallengeStatus"]:ChallengeStatus;
	["ChallengeTrackingStatus"]:ChallengeTrackingStatus;
	["Users"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	password?:boolean | `@${string}`,
	passwordResetToken?:boolean | `@${string}`,
	passwordResetExpiryDate?:boolean | `@${string}`,
	activateAccountToken?:boolean | `@${string}`,
	activateAccountExpiryDate?:boolean | `@${string}`,
	emailVerified?:boolean | `@${string}`,
	verifyEmailToken?:boolean | `@${string}`,
	verifyEmailExpiryDate?:boolean | `@${string}`,
	unlockedDate?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	ecole?:boolean | `@${string}`,
	refreshToken?:boolean | `@${string}`,
	role?:ResolverInputTypes["Roles"],
	roleId?:boolean | `@${string}`,
	tutorEmail?:boolean | `@${string}`,
	satisfactionQuiz?:boolean | `@${string}`,
	satisfactionQuizContent?:boolean | `@${string}`,
	trackingEntity?:ResolverInputTypes["Tracking"],
	motionViewed?:boolean | `@${string}`,
	firstCardDraw?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AccountStatus"]:AccountStatus;
	/** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
["JSON"]:unknown;
	["UserPagination"]: AliasType<{
	users?:ResolverInputTypes["Users"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Roles"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	users?:ResolverInputTypes["Users"],
		__typename?: boolean | `@${string}`
}>;
	["UniqueAuth"]: AliasType<{
	access_token?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	ecole?:boolean | `@${string}`,
	sub?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Mail"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Stats"]: AliasType<{
	question?:boolean | `@${string}`,
	answerNumber?:boolean | `@${string}`,
	yes?:boolean | `@${string}`,
	littleYes?:boolean | `@${string}`,
	middle?:boolean | `@${string}`,
	littleNo?:boolean | `@${string}`,
	no?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StatsPagination"]: AliasType<{
	stats?:ResolverInputTypes["Stats"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Query"]: AliasType<{
	getHealthGql?:ResolverInputTypes["Health"],
getRole?: [{	id: number},ResolverInputTypes["Roles"]],
	getRoles?:ResolverInputTypes["Roles"],
getMail?: [{	id: number},ResolverInputTypes["Mail"]],
	getMails?:ResolverInputTypes["Mail"],
	sendMail?:boolean | `@${string}`,
loginAsGuest?: [{	email: string},ResolverInputTypes["AuthType"]],
login?: [{	email: string,	password: string},ResolverInputTypes["AuthType"]],
uniqueAuthFromSso?: [{	code: string},ResolverInputTypes["UniqueAuth"]],
getUser?: [{	id: number},ResolverInputTypes["Users"]],
	getUsers?:ResolverInputTypes["Users"],
getFilteredUsers?: [{	findManyUserWithFiltersInput: ResolverInputTypes["FindManyUserWithFiltersInput"]},ResolverInputTypes["UserPagination"]],
	getThematics?:ResolverInputTypes["Thematic"],
getFilteredStats?: [{	findManyStatWithFiltersInput: ResolverInputTypes["FindManyStatWithFiltersInput"]},ResolverInputTypes["StatsPagination"]],
		__typename?: boolean | `@${string}`
}>;
	["AuthType"]: AliasType<{
	Tokens?:ResolverInputTypes["Tokens"],
	CustomError?:ResolverInputTypes["CustomError"],
		__typename?: boolean | `@${string}`
}>;
	["Tokens"]: AliasType<{
	access_token?:boolean | `@${string}`,
	refresh_token?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomError"]: AliasType<{
	error?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["EError"]:EError;
	["FindManyUserWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput: string,
	orderBy?: ResolverInputTypes["UserOrderByInput"] | undefined | null,
	filterBy?: ResolverInputTypes["UserFilterByInput"] | undefined | null
};
	["UserOrderByInput"]: {
	email?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	firstName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	lastName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	lastConnectionAt?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	role?: ResolverInputTypes["OrderByEnum"] | undefined | null
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<number> | undefined | null
};
	["FindManyStatWithFiltersInput"]: {
	skip: number,
	take: number
};
	["Mutation"]: AliasType<{
askForResetPassword?: [{	email: string},boolean | `@${string}`],
resetPassword?: [{	email: string,	password: string,	token: string},boolean | `@${string}`],
verifyEmail?: [{	email: string,	token: string},boolean | `@${string}`],
register?: [{	email: string,	password: string,	firstName: string,	lastName: string},ResolverInputTypes["AuthType"]],
askForRegister?: [{	registerUserInput: ResolverInputTypes["RegisterUserInput"]},boolean | `@${string}`],
finishRegister?: [{	email: string,	password: string,	firstName: string,	lastName: string,	token: string},boolean | `@${string}`],
finishRegisterAsGuest?: [{	email: string,	password: string,	firstName: string,	lastName: string},boolean | `@${string}`],
	refresh?:ResolverInputTypes["AuthType"],
	logout?:boolean | `@${string}`,
createUser?: [{	createUserInput: ResolverInputTypes["CreateUserInput"]},ResolverInputTypes["Users"]],
updateUser?: [{	updateUserInput: ResolverInputTypes["UpdateUserInput"]},ResolverInputTypes["Users"]],
deleteUser?: [{	id: number},boolean | `@${string}`],
updateTutorEmail?: [{	userId: number,	tutorEmail: string},ResolverInputTypes["Users"]],
updateSatisfactionQuiz?: [{	userId: number,	content: ResolverInputTypes["JSON"]},ResolverInputTypes["Users"]],
updateMotionViewed?: [{	userId: number},ResolverInputTypes["Users"]],
updateFirstCardDraw?: [{	userId: number},ResolverInputTypes["Users"]],
createTracking?: [{	userId: number,	thematicId: number},ResolverInputTypes["Tracking"]],
deleteTracking?: [{	trackingId: number},boolean | `@${string}`],
validateTracking?: [{	trackingId: number,	text: string},boolean | `@${string}`],
validateQuiz?: [{	quizId: number,	trackingId: number,	answerId: number},ResolverInputTypes["Tracking"]],
		__typename?: boolean | `@${string}`
}>;
	["RegisterUserInput"]: {
	email: string,
	roleId: number
};
	["CreateUserInput"]: {
	email: string,
	password: string,
	firstName: string,
	lastName: string,
	roleId: number
};
	["UpdateUserInput"]: {
	email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	roleId?: number | undefined | null,
	id: number
};
	["schema"]: AliasType<{
	query?:ResolverInputTypes["Query"],
	mutation?:ResolverInputTypes["Mutation"],
		__typename?: boolean | `@${string}`
}>
  }

export type ModelTypes = {
    ["Health"]: {
		env: string,
	time: string,
	status: string
};
	["Answer"]: {
		id: number,
	name: string,
	text: string,
	isCorrect: boolean,
	quiz: ModelTypes["Quiz"],
	quizId: number
};
	["AnswersWithoutCorrect"]: {
		id: number,
	name: string,
	text: string,
	quiz: ModelTypes["Quiz"],
	quizId: number
};
	["Quiz"]: {
		id: number,
	name: string,
	question: string,
	quizType: ModelTypes["QuizType"],
	answers: Array<ModelTypes["Answer"]>,
	challenge: ModelTypes["Challenge"],
	challengeId: number
};
	["QuizType"]:QuizType;
	["Thematic"]: {
		id: number,
	name: string,
	asset: string,
	challenges: Array<ModelTypes["Challenge"]>
};
	["Challenge"]: {
		id: number,
	name: string,
	description: string,
	asset: string,
	helpText: string,
	difficulty: ModelTypes["ChallengeDifficulty"],
	quizzes: Array<ModelTypes["Quiz"]>,
	trackings: Array<ModelTypes["Tracking"]>,
	thematic: ModelTypes["Thematic"],
	thematicId: number
};
	["ChallengeDifficulty"]:ChallengeDifficulty;
	["QuizResponse"]: {
		id: number,
	isCorrect: boolean,
	done: boolean,
	quizId: number,
	challenge: ModelTypes["Challenge"],
	challengeId: number
};
	["Tracking"]: {
		id: number,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	user: ModelTypes["Users"],
	userId: number,
	challengeStatus: ModelTypes["ChallengeStatus"],
	challengeTrackingStatus: ModelTypes["ChallengeTrackingStatus"],
	challenge: ModelTypes["Challenge"],
	quizResponses: Array<ModelTypes["QuizResponse"]>
};
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:any;
	["ChallengeStatus"]:ChallengeStatus;
	["ChallengeTrackingStatus"]:ChallengeTrackingStatus;
	["Users"]: {
		id: number,
	uuid: string,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	status: ModelTypes["AccountStatus"],
	email: string,
	password: string,
	passwordResetToken?: string | undefined,
	passwordResetExpiryDate?: ModelTypes["DateTime"] | undefined,
	activateAccountToken?: string | undefined,
	activateAccountExpiryDate?: ModelTypes["DateTime"] | undefined,
	emailVerified: boolean,
	verifyEmailToken?: string | undefined,
	verifyEmailExpiryDate?: ModelTypes["DateTime"] | undefined,
	unlockedDate?: ModelTypes["DateTime"] | undefined,
	firstName: string,
	lastName: string,
	ecole: string,
	refreshToken?: string | undefined,
	role: ModelTypes["Roles"],
	roleId: number,
	tutorEmail?: string | undefined,
	satisfactionQuiz: boolean,
	satisfactionQuizContent?: ModelTypes["JSON"] | undefined,
	trackingEntity?: Array<ModelTypes["Tracking"]> | undefined,
	motionViewed: boolean,
	firstCardDraw: boolean
};
	["AccountStatus"]:AccountStatus;
	/** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
["JSON"]:any;
	["UserPagination"]: {
		users: Array<ModelTypes["Users"] | undefined>,
	total: number
};
	["Roles"]: {
		id: number,
	uuid: string,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	users: Array<ModelTypes["Users"] | undefined>
};
	["UniqueAuth"]: {
		access_token: string,
	firstName: string,
	lastName: string,
	role: string,
	email: string,
	ecole: string,
	sub: number
};
	["Mail"]: {
		id: number,
	uuid: string,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	key: string,
	to: string,
	data: string
};
	["Stats"]: {
		question: string,
	answerNumber: number,
	yes: number,
	littleYes: number,
	middle: number,
	littleNo: number,
	no: number
};
	["StatsPagination"]: {
		stats: Array<ModelTypes["Stats"] | undefined>,
	total: number
};
	["Query"]: {
		getHealthGql: ModelTypes["Health"],
	getRole: ModelTypes["Roles"],
	getRoles: Array<ModelTypes["Roles"]>,
	getMail: ModelTypes["Mail"],
	getMails: Array<ModelTypes["Mail"]>,
	sendMail: boolean,
	loginAsGuest: ModelTypes["AuthType"],
	login: ModelTypes["AuthType"],
	uniqueAuthFromSso: ModelTypes["UniqueAuth"],
	getUser: ModelTypes["Users"],
	getUsers: Array<ModelTypes["Users"]>,
	getFilteredUsers: ModelTypes["UserPagination"],
	getThematics: Array<ModelTypes["Thematic"]>,
	getFilteredStats: ModelTypes["StatsPagination"]
};
	["AuthType"]:ModelTypes["Tokens"] | ModelTypes["CustomError"];
	["Tokens"]: {
		access_token: string,
	refresh_token: string
};
	["CustomError"]: {
		error: ModelTypes["EError"],
	message: string
};
	["EError"]:EError;
	["FindManyUserWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput: string,
	orderBy?: ModelTypes["UserOrderByInput"] | undefined,
	filterBy?: ModelTypes["UserFilterByInput"] | undefined
};
	["UserOrderByInput"]: {
	email?: ModelTypes["OrderByEnum"] | undefined,
	firstName?: ModelTypes["OrderByEnum"] | undefined,
	lastName?: ModelTypes["OrderByEnum"] | undefined,
	lastConnectionAt?: ModelTypes["OrderByEnum"] | undefined,
	role?: ModelTypes["OrderByEnum"] | undefined
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<number> | undefined
};
	["FindManyStatWithFiltersInput"]: {
	skip: number,
	take: number
};
	["Mutation"]: {
		askForResetPassword: boolean,
	resetPassword: boolean,
	verifyEmail: boolean,
	register: ModelTypes["AuthType"],
	askForRegister: boolean,
	finishRegister: boolean,
	finishRegisterAsGuest: boolean,
	refresh: ModelTypes["AuthType"],
	logout: boolean,
	createUser: ModelTypes["Users"],
	updateUser: ModelTypes["Users"],
	deleteUser: boolean,
	updateTutorEmail: ModelTypes["Users"],
	updateSatisfactionQuiz: ModelTypes["Users"],
	updateMotionViewed: ModelTypes["Users"],
	updateFirstCardDraw: ModelTypes["Users"],
	createTracking: ModelTypes["Tracking"],
	deleteTracking: boolean,
	validateTracking: boolean,
	validateQuiz: ModelTypes["Tracking"]
};
	["RegisterUserInput"]: {
	email: string,
	roleId: number
};
	["CreateUserInput"]: {
	email: string,
	password: string,
	firstName: string,
	lastName: string,
	roleId: number
};
	["UpdateUserInput"]: {
	email?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	roleId?: number | undefined,
	id: number
};
	["schema"]: {
	query?: ModelTypes["Query"] | undefined,
	mutation?: ModelTypes["Mutation"] | undefined
}
    }

export type GraphQLTypes = {
    // ------------------------------------------------------;
	// THIS FILE WAS AUTOMATICALLY GENERATED (DO NOT MODIFY);
	// ------------------------------------------------------;
	["Health"]: {
	__typename: "Health",
	env: string,
	time: string,
	status: string
};
	["Answer"]: {
	__typename: "Answer",
	id: number,
	name: string,
	text: string,
	isCorrect: boolean,
	quiz: GraphQLTypes["Quiz"],
	quizId: number
};
	["AnswersWithoutCorrect"]: {
	__typename: "AnswersWithoutCorrect",
	id: number,
	name: string,
	text: string,
	quiz: GraphQLTypes["Quiz"],
	quizId: number
};
	["Quiz"]: {
	__typename: "Quiz",
	id: number,
	name: string,
	question: string,
	quizType: GraphQLTypes["QuizType"],
	answers: Array<GraphQLTypes["Answer"]>,
	challenge: GraphQLTypes["Challenge"],
	challengeId: number
};
	["QuizType"]: QuizType;
	["Thematic"]: {
	__typename: "Thematic",
	id: number,
	name: string,
	asset: string,
	challenges: Array<GraphQLTypes["Challenge"]>
};
	["Challenge"]: {
	__typename: "Challenge",
	id: number,
	name: string,
	description: string,
	asset: string,
	helpText: string,
	difficulty: GraphQLTypes["ChallengeDifficulty"],
	quizzes: Array<GraphQLTypes["Quiz"]>,
	trackings: Array<GraphQLTypes["Tracking"]>,
	thematic: GraphQLTypes["Thematic"],
	thematicId: number
};
	["ChallengeDifficulty"]: ChallengeDifficulty;
	["QuizResponse"]: {
	__typename: "QuizResponse",
	id: number,
	isCorrect: boolean,
	done: boolean,
	quizId: number,
	challenge: GraphQLTypes["Challenge"],
	challengeId: number
};
	["Tracking"]: {
	__typename: "Tracking",
	id: number,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	user: GraphQLTypes["Users"],
	userId: number,
	challengeStatus: GraphQLTypes["ChallengeStatus"],
	challengeTrackingStatus: GraphQLTypes["ChallengeTrackingStatus"],
	challenge: GraphQLTypes["Challenge"],
	quizResponses: Array<GraphQLTypes["QuizResponse"]>
};
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]: "scalar" & { name: "DateTime" };
	["ChallengeStatus"]: ChallengeStatus;
	["ChallengeTrackingStatus"]: ChallengeTrackingStatus;
	["Users"]: {
	__typename: "Users",
	id: number,
	uuid: string,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	status: GraphQLTypes["AccountStatus"],
	email: string,
	password: string,
	passwordResetToken?: string | undefined,
	passwordResetExpiryDate?: GraphQLTypes["DateTime"] | undefined,
	activateAccountToken?: string | undefined,
	activateAccountExpiryDate?: GraphQLTypes["DateTime"] | undefined,
	emailVerified: boolean,
	verifyEmailToken?: string | undefined,
	verifyEmailExpiryDate?: GraphQLTypes["DateTime"] | undefined,
	unlockedDate?: GraphQLTypes["DateTime"] | undefined,
	firstName: string,
	lastName: string,
	ecole: string,
	refreshToken?: string | undefined,
	role: GraphQLTypes["Roles"],
	roleId: number,
	tutorEmail?: string | undefined,
	satisfactionQuiz: boolean,
	satisfactionQuizContent?: GraphQLTypes["JSON"] | undefined,
	trackingEntity?: Array<GraphQLTypes["Tracking"]> | undefined,
	motionViewed: boolean,
	firstCardDraw: boolean
};
	["AccountStatus"]: AccountStatus;
	/** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
["JSON"]: "scalar" & { name: "JSON" };
	["UserPagination"]: {
	__typename: "UserPagination",
	users: Array<GraphQLTypes["Users"] | undefined>,
	total: number
};
	["Roles"]: {
	__typename: "Roles",
	id: number,
	uuid: string,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	users: Array<GraphQLTypes["Users"] | undefined>
};
	["UniqueAuth"]: {
	__typename: "UniqueAuth",
	access_token: string,
	firstName: string,
	lastName: string,
	role: string,
	email: string,
	ecole: string,
	sub: number
};
	["Mail"]: {
	__typename: "Mail",
	id: number,
	uuid: string,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	key: string,
	to: string,
	data: string
};
	["Stats"]: {
	__typename: "Stats",
	question: string,
	answerNumber: number,
	yes: number,
	littleYes: number,
	middle: number,
	littleNo: number,
	no: number
};
	["StatsPagination"]: {
	__typename: "StatsPagination",
	stats: Array<GraphQLTypes["Stats"] | undefined>,
	total: number
};
	["Query"]: {
	__typename: "Query",
	getHealthGql: GraphQLTypes["Health"],
	getRole: GraphQLTypes["Roles"],
	getRoles: Array<GraphQLTypes["Roles"]>,
	getMail: GraphQLTypes["Mail"],
	getMails: Array<GraphQLTypes["Mail"]>,
	sendMail: boolean,
	loginAsGuest: GraphQLTypes["AuthType"],
	login: GraphQLTypes["AuthType"],
	uniqueAuthFromSso: GraphQLTypes["UniqueAuth"],
	getUser: GraphQLTypes["Users"],
	getUsers: Array<GraphQLTypes["Users"]>,
	getFilteredUsers: GraphQLTypes["UserPagination"],
	getThematics: Array<GraphQLTypes["Thematic"]>,
	getFilteredStats: GraphQLTypes["StatsPagination"]
};
	["AuthType"]:{
        	__typename:"Tokens" | "CustomError"
        	['...on Tokens']: '__union' & GraphQLTypes["Tokens"];
	['...on CustomError']: '__union' & GraphQLTypes["CustomError"];
};
	["Tokens"]: {
	__typename: "Tokens",
	access_token: string,
	refresh_token: string
};
	["CustomError"]: {
	__typename: "CustomError",
	error: GraphQLTypes["EError"],
	message: string
};
	["EError"]: EError;
	["FindManyUserWithFiltersInput"]: {
		skip: number,
	take: number,
	searchInput: string,
	orderBy?: GraphQLTypes["UserOrderByInput"] | undefined,
	filterBy?: GraphQLTypes["UserFilterByInput"] | undefined
};
	["UserOrderByInput"]: {
		email?: GraphQLTypes["OrderByEnum"] | undefined,
	firstName?: GraphQLTypes["OrderByEnum"] | undefined,
	lastName?: GraphQLTypes["OrderByEnum"] | undefined,
	lastConnectionAt?: GraphQLTypes["OrderByEnum"] | undefined,
	role?: GraphQLTypes["OrderByEnum"] | undefined
};
	["OrderByEnum"]: OrderByEnum;
	["UserFilterByInput"]: {
		role?: Array<number> | undefined
};
	["FindManyStatWithFiltersInput"]: {
		skip: number,
	take: number
};
	["Mutation"]: {
	__typename: "Mutation",
	askForResetPassword: boolean,
	resetPassword: boolean,
	verifyEmail: boolean,
	register: GraphQLTypes["AuthType"],
	askForRegister: boolean,
	finishRegister: boolean,
	finishRegisterAsGuest: boolean,
	refresh: GraphQLTypes["AuthType"],
	logout: boolean,
	createUser: GraphQLTypes["Users"],
	updateUser: GraphQLTypes["Users"],
	deleteUser: boolean,
	updateTutorEmail: GraphQLTypes["Users"],
	updateSatisfactionQuiz: GraphQLTypes["Users"],
	updateMotionViewed: GraphQLTypes["Users"],
	updateFirstCardDraw: GraphQLTypes["Users"],
	createTracking: GraphQLTypes["Tracking"],
	deleteTracking: boolean,
	validateTracking: boolean,
	validateQuiz: GraphQLTypes["Tracking"]
};
	["RegisterUserInput"]: {
		email: string,
	roleId: number
};
	["CreateUserInput"]: {
		email: string,
	password: string,
	firstName: string,
	lastName: string,
	roleId: number
};
	["UpdateUserInput"]: {
		email?: string | undefined,
	firstName?: string | undefined,
	lastName?: string | undefined,
	roleId?: number | undefined,
	id: number
}
    }
export const enum QuizType {
	QCU = "QCU",
	QCM = "QCM"
}
export const enum ChallengeDifficulty {
	EASY = "EASY",
	COMPLEXE = "COMPLEXE"
}
export const enum ChallengeStatus {
	BRONZE = "BRONZE",
	SILVER = "SILVER",
	GOLD = "GOLD",
	PLATINUM = "PLATINUM"
}
export const enum ChallengeTrackingStatus {
	EMPTY = "EMPTY",
	IN_PROGRESS = "IN_PROGRESS",
	COMPLETED = "COMPLETED"
}
export const enum AccountStatus {
	PENDING_ACTIVATION = "PENDING_ACTIVATION",
	ENABLED = "ENABLED",
	DISABLED = "DISABLED"
}
export const enum EError {
	AUTH = "AUTH"
}
export const enum OrderByEnum {
	ASC = "ASC",
	DESC = "DESC"
}

type ZEUS_VARIABLES = {
	["QuizType"]: ValueTypes["QuizType"];
	["ChallengeDifficulty"]: ValueTypes["ChallengeDifficulty"];
	["DateTime"]: ValueTypes["DateTime"];
	["ChallengeStatus"]: ValueTypes["ChallengeStatus"];
	["ChallengeTrackingStatus"]: ValueTypes["ChallengeTrackingStatus"];
	["AccountStatus"]: ValueTypes["AccountStatus"];
	["JSON"]: ValueTypes["JSON"];
	["EError"]: ValueTypes["EError"];
	["FindManyUserWithFiltersInput"]: ValueTypes["FindManyUserWithFiltersInput"];
	["UserOrderByInput"]: ValueTypes["UserOrderByInput"];
	["OrderByEnum"]: ValueTypes["OrderByEnum"];
	["UserFilterByInput"]: ValueTypes["UserFilterByInput"];
	["FindManyStatWithFiltersInput"]: ValueTypes["FindManyStatWithFiltersInput"];
	["RegisterUserInput"]: ValueTypes["RegisterUserInput"];
	["CreateUserInput"]: ValueTypes["CreateUserInput"];
	["UpdateUserInput"]: ValueTypes["UpdateUserInput"];
}